import React from 'react';

import { Dialog, DialogContent } from '@mui/material';
import { DialogHeading } from 'components/dialog-title';
import { GridUserPatientProfilePrescriptionActivities } from '../grid';
import style from './index.module.scss';
import { useTranslate } from 'hooks/use-translate';

import { ignoreEscapeKeyDown } from 'utils/handlers';

const defaultRefresh = () => {};

interface Props {
  userPatientProfilePrescriptionID: string;
  onClose: () => void;
  onRefresh?: () => void;
}

export const DialogUserPatientProfilePrescriptionActivities: React.FC<
  React.PropsWithChildren<Props>
> = ({ userPatientProfilePrescriptionID, onClose, onRefresh = defaultRefresh }) => {
  const { t } = useTranslate();

  return (
    <Dialog
      open={true}
      onClose={ignoreEscapeKeyDown(onClose)}
      fullWidth
      maxWidth="xl"
      classes={{
        paper: style.paper,
      }}
    >
      <DialogHeading title={t('prescription-activities')} onClose={onClose} />
      <DialogContent className={style.content}>
        <GridUserPatientProfilePrescriptionActivities
          className={style.grid}
          userPatientProfilePrescriptionID={userPatientProfilePrescriptionID}
          onRefresh={onRefresh}
        />
      </DialogContent>
    </Dialog>
  );
};
